import { Component, input, Input } from '@angular/core';
import { NgClass } from '@angular/common';

import { DividerComponent } from '../divider/divider.component';

@Component({
  selector: 'app-section-header',
  standalone: true,
  imports: [DividerComponent, NgClass],
  templateUrl: './section-header.component.html',
})
export class SectionHeaderComponent {
  header = input<string>('');
  description = input<string>('');
  sub = input<string>('');
  isLight = input<boolean>(false);
}
